import { Checkbox, Icon } from '@smartgift/frontend-toolkit';
import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import * as SS from '../style';
import { TranslationContext } from '../translation/translationContext';

function SelectionHead({ table, SelectionHead }) {
  const { t } = useTranslation();
  const translations = useContext(TranslationContext);
  const rowSelection = table.getState().rowSelection;

  const selectedRowCount = useMemo(() => {
    return Object.keys(rowSelection).length;
  }, [rowSelection]);

  if (SelectionHead) {
    return (
      <SelectionHead
        table={table}
        selectedRowCount={selectedRowCount}
        selectedRowCountText={translations.selectedRowCountText}
      />
    );
  }

  return (
    <SS.HeadSelected>
      <SS.HeadCheckbox>
        <Checkbox
          {...{
            id: 'selectAll',
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler()
          }}
        />
      </SS.HeadCheckbox>
      <SS.HeadSelectedItems>
        <Icon name="contacts" px={32} space={7} />
        {translations.selectedRowCountText || t('ofItemSelected', { count: selectedRowCount })}
      </SS.HeadSelectedItems>
    </SS.HeadSelected>
  );
}

export default SelectionHead;
